// Daily M2 (rotary era) systems that are not part of a single well's drilling step. Called from tick.js after
// production (gushers have flowed) and before refining.
import { yf } from './defs.js';
import { tickWellControl } from './wellcontrol.js';
import { tickFieldOps } from './fieldops.js';
import { yearlyInspections } from './cement.js';

export function tickRotary(state) {
  if (yf(state) < 1901 && !Object.values(state.wells).some((w) => w.rigType === 'rotary')) return;
  tickWellControl(state);
  tickFieldOps(state);
  yearlyInspections(state);
  // BOPs wear slowly while installed on a working rig; testBop restores them
  for (const rig of Object.values(state.rigs)) {
    const it = rig.bopUid ? state.items[rig.bopUid] : null;
    if (it && rig.wellId) it.condition = Math.max(0, it.condition - 0.05);
  }
}
